<template>
    <div class="single-choice-item">
        <question :text="$t(item.text)" />
        <multi-buttons
            :options="options"
            @select="handleSelect"
        />
    </div>
</template>
<script>
import { CHOICE_RESULTS } from '@/constants/items'
import inputButton from '@/components/inputs/button'
import question from '@/components/ui/question'

import multiButtons from '@/components/inputs/multiButtons'

export default {
    name: 'singleChoiceItem',
    components: {
        question,
        'multi-buttons': multiButtons,
        'input-button': inputButton
    },
    props: {
        item: Object,
        locale: Object
    },
    computed: {
        options() {
            return this.item.choices.map(choice => ({
                value: choice.result,
                text: this.$t(choice.text, { currency: this.locale.currency })
            }))
        }
    },
    methods: {
        handleSelect(selectedChoice) {
            const answer = {
              choice: selectedChoice.value,
              result: 1
            };
            this.$emit('answer', answer)
        }
    }


}
</script>
<style lang="scss">

</style>
